interface AutosaveContextType {
  injected: boolean
  onValueChange: <T>(key: string, value: T) => void
  lastSaveStamp: Ref<number | null> | null
  lastChangeStamp: Ref<number | null> | null
  isSaving: Ref<boolean> | boolean
  changes: ComputedRef<number> | number
  addFieldListener: (key: string, value: any) => () => void
}

export const AutosaveContext = Symbol('ElementalFormContext') as InjectionKey<AutosaveContextType>

export const provideAutosave = (data: AutosaveContextType): void => {
  provide(AutosaveContext, data)
}

export const useAutosave = (): AutosaveContextType => {
  const context = inject(AutosaveContext, {
    injected: false,
    onValueChange: () => {

    },
    lastChangeStamp: null,
    lastSaveStamp: null,
    isSaving: false,
    changes: 0,
    addFieldListener: () => {
      return () => { }
    },
  })

  return context
}
